import { Routes, Route, Link, NavLink, Navigate } from "react-router-dom";
import { RunListPage } from "./pages/RunList";
import { RunDetailPage } from "./pages/RunDetail";
import { ChapterPage } from "./pages/Chapter";

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 mx-auto w-full max-w-6xl px-4 py-6">
        <Routes>
          <Route path="/" element={<RunListPage />} />
          <Route path="/novels/:id" element={<RunDetailPage />} />
          <Route path="/novels/:id/chapter/:chapterNo" element={<ChapterPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function Header() {
  return (
    <header className="border-b border-slate-800 bg-slate-950/80 backdrop-blur sticky top-0 z-10">
      <div className="mx-auto max-w-6xl px-4 py-3 flex items-center gap-6">
        <Link to="/" className="flex items-center gap-2 font-semibold text-lg">
          <span className="text-amber-400 font-bengali text-xl">উপন্যাস</span>
          <span className="text-slate-300">/ Novelist</span>
        </Link>
        <nav className="flex items-center gap-4 text-sm text-slate-300">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              isActive ? "text-amber-300" : "hover:text-slate-100"
            }
          >
            Runs
          </NavLink>
        </nav>
        <div className="flex-1" />
        <a
          href="https://developers.cloudflare.com/workflows/"
          target="_blank"
          rel="noreferrer"
          className="text-xs text-slate-500 hover:text-slate-300"
        >
          powered by Cloudflare Workflows
        </a>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="border-t border-slate-800 text-xs text-slate-500 py-3">
      <div className="mx-auto max-w-6xl px-4 flex items-center justify-between">
        <span>Novelist — autonomous Bengali web novel generator</span>
        <span>Chapters written by Workers AI · State in Neon · Prose in R2</span>
      </div>
    </footer>
  );
}
